module.exports = __webpack_public_path__ + "static/media/edf_logo.b6e3787b.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/edf_logo.bmp
// module id = 661
// module chunks = 0